import config from "@/config/config";

import Index from "@/pages/customer/index.vue";
import List from "@/pages/customer/list/list.vue";
import View from "@/pages/customer/view/view.vue";
import New from "@/pages/customer/new/new.vue";
import Edit from "@/pages/customer/edit/edit.vue";

const modulePermission = config.modules.customer;

export default {
  path: "/customer",
  name: "customer",
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: "enabled_read",
  },
  children: [
    {
      path: "list",
      name: "customer-list",
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
    },
    {
      path: ":id",
      name: "customer-view",
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
      props: true,
    },
    {
      path: "new",
      name: "customer-new",
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_create",
      },
    },
    {
      path: ":id/e",
      name: "customer-edit",
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_edit",
      },
      props: true,
    },
  ],
};
